import { render, staticRenderFns } from "./RegisterProgramme.vue?vue&type=template&id=4696d12c&"
import script from "./RegisterProgramme.vue?vue&type=script&lang=js&"
export * from "./RegisterProgramme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports